import { render, staticRenderFns } from "./goodsPicker.vue?vue&type=template&id=58b3ff5f&scoped=true"
import script from "./goodsPicker.vue?vue&type=script&lang=js"
export * from "./goodsPicker.vue?vue&type=script&lang=js"
import style0 from "./goodsPicker.vue?vue&type=style&index=0&id=58b3ff5f&prod&lang=stylus&scoped=true"
import style1 from "./goodsPicker.vue?vue&type=style&index=1&id=58b3ff5f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b3ff5f",
  null
  
)

export default component.exports